const DAYS_IN_WEEK = 7;

const getPlanDiscountPercent = ({ price, trial, displayOldPrice }) => {
    const oldPrice = displayOldPrice ?? price;
    const newPrice = trial?.price ?? price;

    if (oldPrice === newPrice) {
        return 0;
    }

    return Math.round((1 - Number.parseFloat(newPrice.slice(1)) / Number.parseFloat(oldPrice.slice(1))) * 100);
};

const getBillingDays = ({ unit, value } = {}) => {
    return unit === 'day' ? Number(value) : Number(value) * DAYS_IN_WEEK;
};

export {
    getPlanDiscountPercent,
    getBillingDays
};
